import { gql } from '@apollo/client';

export const PREVIEW_TT_BAG_RULES = gql`
    query PreviewTTBagRules($input: CreateTTBagsInput!) {
        previewTTBagRules(input: $input) {
            rules {
                ttBizType
                nextStop
                carrierCode
                sortingRuleFirst
                sortingRuleSecond
                mappedSortingCode
            }
            totalCount
            errorMessage
        }
    }
`;

export interface TTBagRulePreview {
    ttBizType: string;
    nextStop: string;
    carrierCode: number;
    sortingRuleFirst: string;
    sortingRuleSecond?: string | null;
    mappedSortingCode?: string | null;
}

export interface PreviewTTBagRulesResponse {
    previewTTBagRules: {
        rules: TTBagRulePreview[];
        totalCount: number;
        errorMessage?: string | null;
    };
}
